<template lang="pug" src="./custom-accordion-hero.pug"></template>

<script>
import Icon from '../../icon/icon'

export default {
  props: ['content'],
  data () {
    return {
      show: false,
      mobile: false
    }
  },
  methods: {
    openAccordion (e) {
      var card = e.srcElement.parentElement.parentElement
      if (this.show) {
        this.show = false
        card.classList.remove('hero-accordion__selected')
      } else {
        this.show = true
        card.className += ' hero-accordion__selected'
      }
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// custom-accordion-hero.vue?6713ab5a